// extracted by mini-css-extract-plugin
export var container = "styles-module--container--34c9d";
export var desktop = "1340px";
export var flowerImage = "styles-module--flowerImage--391aa";
export var giant = "2200px";
export var grid = "styles-module--grid--53a4d";
export var header = "styles-module--header--365e9";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var text = "styles-module--text--8c6f5";
export var textContent = "styles-module--textContent--32e42";